import { render, staticRenderFns } from "./DocumentSendEmailHistory.vue?vue&type=template&id=2620ec68&scoped=true"
import script from "./DocumentSendEmailHistory.vue?vue&type=script&lang=js"
export * from "./DocumentSendEmailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620ec68",
  null
  
)

export default component.exports